import api from 'app/api/axios-api';
import { Project, Uploads } from '@app/shared/types/project.type';

export interface MTCPlusProjectRaw {
  projectId: string;
  projectTitle?: string;
  title?: string;
  name?: string;
  description?: string;
  domainName?: string;
  userId?: string;
  uploads?: unknown[];
  created_at?: string;
  updated_at?: string;
}

interface MTCPlusAllProjectsResponse {
  status: number;
  count: number;
  projects: MTCPlusProjectRaw[];
}

interface MTCPlusSingleProjectResponse {
  status: number;
  project?: MTCPlusProjectRaw;
}

export interface CreateMTCPlusProjectParams {
  projectTitle: string;
  description?: string;
  domainName?: string;
  userId?: string;
}

function mapToProject(raw: MTCPlusProjectRaw): Project {
  const title = raw.projectTitle ?? raw.title ?? raw.name ?? '';
  return {
    projectId: raw.projectId,
    title,
    overview: raw.description ?? '',
    domain: (raw.domainName as any) ?? '',
    userId: raw.userId ?? '',
    organizationId: localStorage.getItem('organizationId') ?? '',
    uploads: raw.uploads as Uploads | undefined,
    createdOn: raw.created_at ?? raw.updated_at
  };
}

export async function createMTCPlusProject(params: CreateMTCPlusProjectParams): Promise<Project> {
  const response = await api.post('/mtc-plus/create-new', params);
  const raw = response.data?.project ?? response.data;
  return mapToProject(raw as MTCPlusProjectRaw);
}

export async function fetchMTCPlusProjects(params: { userId: string; excludeUploads?: boolean }): Promise<Project[]> {
  const { userId, excludeUploads } = params;
  if (!userId) {
    throw new Error('Missing required query parameter: userId');
  }
  const query = new URLSearchParams({ userId });
  if (excludeUploads) query.set('excludeUploads', 'true');
  const response = await api.get<MTCPlusAllProjectsResponse>(`/mtc-plus/all-projects?${query.toString()}`);
  const projects = response.data?.projects ?? [];
  return projects.map(mapToProject);
}

export async function fetchMTCPlusProjectById(projectId: string, userId?: string): Promise<Project | null> {
  const query = userId ? `?userId=${encodeURIComponent(userId)}` : '';
  const response = await api.get<MTCPlusSingleProjectResponse>(
    `/mtc-plus/project/${encodeURIComponent(projectId)}${query}`
  );
  const raw = response.data?.project;
  if (!raw) return null;
  return mapToProject(raw);
}
